module.exports = __webpack_public_path__ + "media/images/icon_checked_14-13-c050e28f3644f53ba0769c861aa426f5.png";